export class StringUtils {

    /**
     * Check if a string is empty.
     *
     * @param str
     */
    static isEmpty(str: string): boolean {
        return (typeof str === "undefined" || !str || 0 === str.length);
    }

    static startsWith(str: string, search: string): boolean {
        return str.indexOf(search) === 0;
    }

    static endsWith(str: string, search: string): boolean {
        return (str.length >= search.length) && (str.lastIndexOf(search) === (str.length - search.length));
    }

    /**
     * Parses string into an object.
     *
     * @param query
     */
    static queryStringToObject<T>(query: string): T {
        let match: Array<string>; // Regex for replacing addition symbol with a space
        const pl = /\+/g;
        const search = /([^&=]+)=([^&]*)/g;
        const decode = (s: string): string => decodeURIComponent(decodeURIComponent(s.replace(pl, " ")));
        const obj: {} = {};
        match = search.exec(query);
        while (match) {
            obj[decode(match[1])] = decode(match[2]);
            match = search.exec(query);
        }
        return obj as T;
    }

    /**
     * Trims entries in an array.
     *
     * @param arr
     */
    static trimArrayEntries(arr: Array<string>): Array<string> {
        return arr.map(entry => entry.trim());
    }

    /**
     * Removes empty strings from array
     * @param arr
     */
    static removeEmptyStringsFromArray(arr: Array<string>): Array<string> {
        return arr.filter(entry => {
            return !StringUtils.isEmpty(entry);
        });
    }

    /**
     * Attempts to parse a string into JSON
     * @param str
     */
    static jsonParseHelper<T>(str: string): T {
        try {
            return JSON.parse(str) as T;
        } catch (e) {
            return null;
        }
    }

    static FormatString(str: string, ...val: string[]): string {
        for (let index = 0; index < val.length; index++) {
            str = str.replace(`{${index}}`, val[index]);
        }
        return str;
    }

    static IsValidDateFormat(dateStr: string): boolean {
        const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/;
        return regex.test(dateStr);
    }

    static IsValidCanadaPostalCode(codeStr: string): boolean {
        const regex = /^[A-Za-z]\d[A-Za-z]\s\d[A-Za-z]\d$/;
        return regex.test(codeStr);
    }

    static IsValidUSAZipCode(codeStr: string): boolean {
        const regex = /^\d{5}(-\d{4})?$/;
        return regex.test(codeStr);
    }

    static IsValidEmail(value: string): boolean {
        if (!value) {
            value = "";
        }

        const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

        return regex.test(value);
    }
}